const getPointsTransfer = availablePoints => {
	let pointsOptions = []

	const maxPoints = 10000
	const pointsInterval = 1000

	for (let i = availablePoints; i <= maxPoints; i += pointsInterval) {
		pointsOptions.push({
			value: i,
			label: `${Number(i).toLocaleString('pt-BR')} pontos`
		})
	}

	return pointsOptions
}

export { getPointsTransfer }
